import React from "react";
import StudentResourceTemplate from "./StudentResourceTemplate";

export const resourcePage = {
  id: "bsh-resources",
  department: "Basic Science & Humanities",
  short: "BSH",
  description: "student_resources for the Department of Basic Science & Humanities.",
  resourceSet: "aiml",
  sections: [
    {
      title: "Syllabus",
      items: [
        {
          label: "IA Coverage",
          href: "https://drive.google.com/drive/folders/1bA5OEqWZh1AdwHsh50AMKu7HjmSjNU6m?usp=drive_link",
        },
      ],
    },
    { title: "Timetable", items: [
        // {
        //   label: "1st Semester TimeTable",
        //   href: "/StudentResource/sBSH1/TimeTable/TOT.jpg",
        // },
        // {
        //   label: "2nd Semester TimeTable",
        //   //href: "#",
        // },
        // {
        //   label: "3rd Semester TimeTable",
        //   //href: "#",
        // },
        {
          label: "2nd Semester Chemistry TimeTable",
          href: "/student_resources/BSH/Time Table/time-table-second-sem-chemistry-cycle.pdf",
        },
        // {
        //   label: "5th Semester TimeTable",
        //   //href: "#",
        // },
        {
          label: "2nd Semester Physics TimeTable",
          href: "/student_resources/BSH/Time Table/time-table-second-sem-phy-cycle.pdf",
        },
    ] },
    { title: "Academic Calendar", items: [
      {
          label: "2nd & 4th Even Semester",
          href: "/student_resources/BSH/COE/COE-25-26-AY-revised-2nd-and-4th-sem.xlsx-1.pdf",
        },
    ] },
    // {
    //   title: "Lab Manuals",
    //   items: [
    //     {
    //       label: "Lab Manuals",
    //       href: "",
    //     },
    //   ],
    // },
    {
        title: "Question Papers & Solutions",
        items: [
          {
            label: "Question Paper and Solution",
            href: "https://drive.google.com/drive/folders/1L8Yg6el6ew-EjdqpPr4-p6zALroiLIeN?usp=drive_link",
          },
        ],
      },
    // {
    //   title: "Add-On Subjects",
    //   items: [
    //     {
    //       label: "Add-On Course Syllabus",
    //       href: "/resources/student-resources/aiml/addon-course/4th-sem-add-on-1-syllabus.pdf",
    //     },
    //   ],
    // },
    // {
    //   title: "Published Papers & Patents",
    //   items: [
    //     {
    //       label: " INTEGRATED LEGAL CASE ANALYSIS AND DOCUMENT GENERATION SYSTEM USING RETRIEVAL-AUGMENTED AI MODELS ",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-396.pdf",
    //     },
    //     {
    //       label: " NETWORK TRAFFIC ANALYSIS FOR SECURITY ANOMALY ",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-799.pdf",
    //     },
    //     {
    //       label: " CROWD SENSE: A REAL-TIME SYSTEM FOR CROWD ANALYTICS",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-883.pdf",
    //     },
    //     {
    //       label: " AI-DRIVEN MOBILE FORENSICS",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-1145.pdf",
    //     },
    //     {
    //       label: " AI-BASED TEXT TO 3D MODEL GENERATOR",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-1793-793.pdf",
    //     },
    //   ],
    // },
    {
      title: "Mentor List",
      items: [
        {
          label: "2025-26",
          href: "/student_resources/BSH/Mentor-Mentee/Adobe-Scan-27-Mar-2026-1.pdf",
        },
      ],
    },
  ],
};

const BSHResources = () => <StudentResourceTemplate resourcePage={resourcePage} />;

export default BSHResources;
